module.exports = __webpack_public_path__ + "img/about.727b3eda.jpg";